<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card :loading="isLoading">
      <v-card-title>
        {{ isEdit ? 'Редактировать' : 'Новый' }} тип файла
      </v-card-title>
      <v-card-text>
        <v-container>
          <attachments-form
            :item="item"
            :is-edit="isEdit"
            @submit="onSubmit"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import AttachmentsForm from './AttachmentsForm.vue';

const createDefaultItem = () => ({
  name: '',
  fileType: null,
  maxFileSizeMb: 0,
});

export default {
  name: 'attachments-dialog',

  components: { AttachmentsForm },

  mixins: [DialogBusMixin],

  data: () => ({
    dialog: false,
    isLoading: false,
    item: createDefaultItem(),
    isEdit: false,
  }),

  methods: {
    ...mapActions('attachments', ['create', 'update', 'getList']),
    ...mapActions(['showNotify']),

    beforeOpen({ item }) {
      this.isEdit = !!item;
      this.item = item ? JSON.parse(JSON.stringify(item)) : createDefaultItem();
    },

    async onSubmit() {
      this.isLoading = true;

      try {
        if (this.isEdit) {
          await this.update(this.item);
        } else {
          await this.create(this.item);
        }
        this.showNotify({ message: `Параметры файла ${this.item.name} успешно сохранены` });
        await this.getList();
        this.dialog = false;
      } catch (e) {
        this.showNotify({ type: 'error', message: e.message });
      }

      this.isLoading = false;
    },
  },
};
</script>
